import AddressUtils from './addressUtils';
import DateUtils from './dateUtils';
import defaultTheme from '../assets/styles/theme';
import { FormatType } from '../local-types';

export default class FormattingUtils {
    static price(amount: any, allowZero: boolean = false): string {
        if ((allowZero ? '' !== amount : amount) && !isNaN(amount)) {
            return Number(amount).toFixed(2) + ' €';
        }
        return '0.00 €';
    }

    static numberToColor(value: number): string {
        if (value === 0) {
            return defaultTheme.palette.colors.greyDark;
        }
        if (value < 0) {
            return defaultTheme.palette.colors.red;
        }
        return defaultTheme.palette.colors.green;
    }

    static fraudscoreToStyle(value: number): { color: string; fontSize?: number } {
        const mapping = [
            { limit: 0, color: 'grey' },
            { limit: 1, color: 'green' },
            { limit: 32, color: 'yellowgreen', fontSize: 16 },
            { limit: 40, color: 'orange', fontSize: 18 },
            { limit: 60, color: 'red', fontSize: 20 },
            { limit: 90, color: 'crimson', fontSize: 22 },
        ];
        const res: any = {};
        const element = mapping.reverse().find((x) => value >= x.limit);
        res.color = element?.color || 'blue';
        if (element?.fontSize) {
            res.fontSize = element?.fontSize;
        }
        return res;
    }

    static format(value: any, type: FormatType, t: any): any {
        let res = value;
        switch (type) {
            case FormatType.DateShort:
                res = DateUtils.tsToDate(value, true);
                break;
            case FormatType.DateLong:
                res = DateUtils.tsToDate(value, false);
                break;
            case FormatType.Boolean:
                res = value ? t('common:true') : t('common:false');
                break;
            case FormatType.BooleanString:
                res = Boolean(value) ? t('common:true') : t('common:false');
                break;
            case FormatType.Address:
                res = AddressUtils.objectToAddress(value?.address || value);
                break;
            case FormatType.Price:
                res = FormattingUtils.price(value, true);
                break;
            case FormatType.Phone:
            case FormatType.Email:
                //TODO: add regex format
                break;
            case FormatType.Object:
                if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
                    res = JSON.stringify(value);
                }
                break;
            default:
                break;
        }

        // Used to remove duplicate in arrays
        if (Array.isArray(value)) {
            res = [...new Set(value)];
        }

        return res;
    }
}
